import { FC } from 'react';
import { Bell } from 'lucide-react';
import { type Notification } from '@teachur/http-client';
import { NotificationItem } from '../NotificationItem/NotificationItem';

interface NotificationsListProps {
  notifications: Notification[];
  onMarkAsRead?: (id: number) => void;
  onNotificationClick?: (notification: Notification) => void;
  emptyMessage?: string;
}

export const NotificationsList: FC<NotificationsListProps> = ({
  notifications,
  onMarkAsRead,
  onNotificationClick,
  emptyMessage = 'No notifications',
}) => {
  if (notifications.length === 0) {
    return (
      <div className="flex flex-col items-center justify-center py-12 px-4 text-center">
        <Bell className="w-12 h-12 text-gray-300 mb-3" />
        <p className="text-gray-500 text-sm">{emptyMessage}</p>
      </div>
    );
  }

  return (
    <div className="divide-y divide-gray-100">
      {notifications.map((notification) => (
        <NotificationItem
          key={notification.id}
          notification={notification}
          onMarkAsRead={onMarkAsRead}
          onClick={onNotificationClick}
        />
      ))}
    </div>
  );
};
